import PermissionsLink from 'components/PermissionsLink';
import React from 'react';
import { getAnnotatedTestSentenceResult } from 'selectors/communications';
import { useSelector } from 'store';
import type { RuleResultsV2, RuleRevision } from 'types';

type RulesViolatedFrom = 'identifiers' | 'models';

type ComponentProps = {
  rulesViolated: RuleResultsV2[];
  classes?: string;
  rulesViolatedFrom?: RulesViolatedFrom;
  showV2?: boolean;
};

const SentencesViolatedSectionGlobal: React.FC<ComponentProps> = ({
  rulesViolated,
  classes,
  rulesViolatedFrom,
  showV2 = false,
}) => {
  const resultLines = useSelector(getAnnotatedTestSentenceResult);

  if (!resultLines || !rulesViolated || rulesViolated.length === 0) {
    return (
      <div
        className={`min-h-30 p-4 flex flex-col flex-grow-1 gap-2 items-start w-1/4 ${classes} bg-litlingo-gray-1 text-body`}
      >
        <span className="font-bold" data-testid="matched-title">
          Matches Found:
        </span>
        <span className="pl-4 pr-20 text-small italic">
          Run test to see results, any matches will show up here.
        </span>
      </div>
    );
  }

  if (rulesViolated && rulesViolated.length !== 0) {
    return (
      <div
        className={`min-h-30 p-4 flex flex-col gap-2 items-start w-1/4 ${classes} bg-litlingo-highlight text-body`}
      >
        <span className="font-bold" data-testid="matched-title">
          Matches Found:
        </span>
        <div className="pl-4">
          <ol className="list-decimal pl-4 flex flex-col gap-1 text-small whitespace-no-wrap">
            {rulesViolated.map((ruleItem) => (
              <li key={ruleItem.rule.uuid} className="w-full text-litlingo-primary">
                {(ruleItem?.rule as RuleRevision)?.rule_group_uuid && (
                  <PermissionsLink
                    routeName="global-rule-group-manager"
                    routeParams={{
                      ruleId: (ruleItem.rule as RuleRevision).rule_group_uuid,
                    }}
                    className="text-litlingo-primary hover:underline"
                    action="rules.retrieve"
                  >
                    {ruleItem.rule.name}
                  </PermissionsLink>
                )}
              </li>
            ))}
          </ol>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`w-1/3 flex flex-col items-start ${classes}  ${
        showV2 ? 'bg-litlingo-gray-6' : 'litlingo-gray-bg-color-3'
      }`}
    >
      <div className="flex inline-flex pt-2 pb-4 px-4">
        <svg
          className="h-5 w-5 mr-2 text text--bold"
          fill="#FCFCFC"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
          viewBox="-0.5 0 22 20"
          stroke="#FCFCFC"
        >
          <path d="M0 10a10 10 0 1120 0 10 10 0 01-20 0zm16.32-4.9L5.09 16.31A8 8 0 0016.32 5.09zm-1.41-1.42A8 8 0 003.68 14.91L14.91 3.68z" />
        </svg>
        <span className="text-xl text text--bold text--white">
          {`No ${rulesViolatedFrom === 'models' ? 'model' : 'identifier'} matched`}
        </span>
      </div>
    </div>
  );
};

export default SentencesViolatedSectionGlobal;
